import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'bwa',
  title: 'BWA',
  description:
    'Betriebswirtschaftliche Auswertungen, transparente Bereinigungen und integrierte Planung.',
  icon: 'ChartColumn',
  order: 130,
  apiBasePath: '/api/bwa',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Leeres Array: für alle angemeldeten Nutzer sichtbar.
  // Sobald hier eine Rolle steht, sehen nur Nutzer mit dieser Rolle das Modul.
  roles: ['bwa.nutzer', 'bwa.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
